var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ak-type-input',{attrs:{"hideLabel":"","field":_vm.options},model:{value:(_vm.data.state),callback:function ($$v) {_vm.$set(_vm.data, "state", $$v)},expression:"data.state"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }